<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: "BenefitComponent",
};
</script>

<style scoped></style>
